import { useQuery, UseQueryResult } from "react-query";
import { useAuth } from "../../sdk/hooks";
import * as scheduleApi from "../../sdk/utils/api/price-change-schedule";
import { IPriceChangeSchedule } from "../../sdk/utils/api/price-change-schedule";

export const useGetSchedules = (
    queryKey: string,
    variantId: string,
    options?: { enabled?: boolean }
): UseQueryResult<IPriceChangeSchedule[]> => {
    const { token } = useAuth();

    return useQuery<IPriceChangeSchedule[]>(
        queryKey,
        async () => {
            if (!token) throw new Error("Not authenticated");
            return await scheduleApi.getSchedulesForVariant(token, variantId);
        },
        options
    );
};
